module.exports = __webpack_public_path__ + "img/download-04.a2383b08.svg";